import React from 'react';
import { useSelector } from 'react-redux';
import { IKIOSKModel } from '../../../../models/kioskModel2';
import Themetwomanager from '../components/themetwomanager';
import ErrorMessageModel from '../../theme1/components/errorMessageModel';
import PageLoading from '../components/pageLoading';

const ThemeTwoKioskContainer: React.FC = () => {
    const loadings: boolean = useSelector((state: any) => (state.kioskReducer2 as IKIOSKModel)?.loading || false);
    const errorMessage: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.errorMessage || "");

    return (
        <>
         <PageLoading />
            {!loadings &&
                <div className="containerbg">
                    {errorMessage !=="" ? <ErrorMessageModel /> :  <Themetwomanager />}
                </div>
            }
        </>
    );
}
export default ThemeTwoKioskContainer;